/**
 * Phase 6 Plan 02 — useCleaningSettings (CADENCE-6.1).
 *
 * TanStack Query GET hook keyed CLEANING_SETTINGS_KEY; queryFn calls
 * fetchCleaningSettings. staleTime: 30s mirrors Plan 04-04 useAssetInspections
 * + Phase 5 Plan 05 useQueueHealth precedents.
 */
import { useQuery } from "@tanstack/react-query";
import { ApiError } from "../../api/client";
import {
  CLEANING_SETTINGS_KEY,
  fetchCleaningSettings,
  type CleaningSettingsRead,
} from "../../api/cleaningSettings";

export function useCleaningSettings() {
  return useQuery<CleaningSettingsRead, ApiError>({
    queryKey: CLEANING_SETTINGS_KEY,
    queryFn: fetchCleaningSettings,
    staleTime: 30_000,
  });
}
